import { IconButton, Theme, Tooltip } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { CodeArtifactSCMTypes } from '../../types/artifacts-type';
import { getScmIconType } from '../../utils/artifacts-utils';
import { ReactComponent as GenericIcon } from '../../../assets/icons/generic-icon.svg';

const ArtifactCodeCell: FC<React.PropsWithChildren<ArtifactCodeCellProps>> = ({
  scm,
  url,
}) => {
  const { classes } = useStyles();
  const SCMIcon = scm ? getScmIconType(scm) : GenericIcon;
  return (
    <Tooltip title={scm} arrow placement='top'>
      <div className={classes.artifactCodeCell}>
        {SCMIcon && (
          <IconButton
            size='small'
            target='_blank'
            href={url}
            style={{ backgroundColor: 'transparent' }}>
            <SCMIcon className={classes.repoIcon} />
          </IconButton>
        )}
      </div>
    </Tooltip>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  artifactCodeCell: {
    display: 'inline-flex',
    gap: theme.spacing(0.5),
    alignItems: 'center',
  },
  repoIcon: {
    width: 'auto',
    height: '1em',
    flexShrink: 0,
  },
}));

export interface ArtifactCodeCellProps {
  scm: CodeArtifactSCMTypes;
  url: string;
}

export default ArtifactCodeCell;
